"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var abi_1 = require("./abi");

var keccak_1 = require("./keccak");

exports.sha3 = keccak_1.keccak256;

function soliditySha3() {
  return keccak_1.keccak256(abi_1.encodePacked.apply(abi_1, arguments));
}

exports.soliditySha3 = soliditySha3;